import RedirectFormUi from './RedirectFormUi';

export default RedirectFormUi;
